// ./js/common/modal.js
export function initModal() {
  const modal = document.querySelector(".js-modal");
  if (!modal) return;

  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  const img = modal.querySelector(".js-modal-img img");
  const openers = document.querySelectorAll(".js-modal-trigger");
  const closers = modal.querySelectorAll(".js-modal-close");

  let lastActive = null;

  const onKeydown = (e) => {
    if (e.key === "Escape") close();
  };

  const open = (src, alt) => {
    lastActive = document.activeElement;
    if (img && src) img.src = src;
    if (img && alt) img.alt = alt;

    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("is-modal-open");
    document.body.classList.add("is-modal-open");

    (modal.querySelector(".js-modal-close") || modal).focus();
    document.addEventListener("keydown", onKeydown);
  };

  const close = () => {
    // 先にフォーカス退避
    if (lastActive && typeof lastActive.focus === "function") {
      lastActive.focus();
    } else {
      document.body.focus();
    }
    document.removeEventListener("keydown", onKeydown);
    document.documentElement.classList.remove("is-modal-open");
    document.body.classList.remove("is-modal-open");
    // その後に非表示化
    modal.setAttribute("aria-hidden", "true");
  };

  openers.forEach((btn) =>
    btn.addEventListener("click", () => {
      open(btn.getAttribute("data-src"), btn.getAttribute("data-alt"));
    })
  );

  closers.forEach((el) => el.addEventListener("click", close));

  // 背景クリック・コンテンツ外クリックで閉じる
  modal.addEventListener("click", (e) => {
    const content = modal.querySelector(".c-modal__content");
    if (!content.contains(e.target)) close();
  });
}
